import logo from '../../resources/logo_lideres2.png';
import { CSidebar, CSidebarBrand, CSidebarNav } from "@coreui/react";
import { shallowEqual } from 'react-redux';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { fetchMenu, resetMenu, selectModules, selectShow, selectUnfoldable, toggleShow, toggleUnfold } from 'features/menu/menuSlice';
import { useEffect, useState } from 'react';
import { Icon } from '@mdi/react';
import { AppSidebarNav } from './AppSidebarNav';
import { logout } from 'features/auth';
import { setVisible, setVisibleSecondary } from 'features/modal';
import { LogoutConfirmModal } from 'components/modal';
import { useResponsive } from 'hooks/useResponsive';
import './AppSidebar.scss';

export const AppSidebar = () => {
  const dispatch = useAppDispatch();
  const unfoldable = useAppSelector((state) => selectUnfoldable(state));
  const sidebarShow = useAppSelector((state) => selectShow(state));
  const modules = useAppSelector((state) => selectModules(state), shallowEqual);
  const { isMobile } = useResponsive();
  
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const exitIcon = require(`materialdesign-js/icons/mdiExitToApp`).default;

  useEffect(() => {
    dispatch(fetchMenu({}));
  }, [dispatch]);

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleLogoutConfirm = () => {
    dispatch(logout());
    dispatch(setVisibleSecondary(false));
    dispatch(setVisible(false));
    dispatch(resetMenu());
    setShowLogoutModal(false);
  };

  const handleLogoutCancel = () => {
    setShowLogoutModal(false);
  };

  return modules.length ? (
    <>
      {isMobile && sidebarShow && (
        <div 
          className="sidebar-overlay"
          onClick={() => dispatch(toggleShow(false))}
        />
      )}
      
      <CSidebar
        position="fixed"
        unfoldable={unfoldable}
        visible={sidebarShow}
        onVisibleChange={(visible) => {
          dispatch(toggleShow(visible));
        }}
        className="custom-sidebar"
      >
        <CSidebarBrand className="sidebar-brand">
          <img 
            src={logo} 
            alt="Líderes en Acción" 
            width={unfoldable ? "40" : "120"} 
            height={unfoldable ? "20" : "60"}
            style={{ transition: 'all 0.3s ease' }}
          />
        </CSidebarBrand>

        <CSidebarNav className="sidebar-nav-container">
            <div className="sidebar-content">
              <AppSidebarNav items={modules} />
            </div>

            <div className="sidebar-bottom-section">
            <div 
              className={`logout-button`}
              onClick={handleLogoutClick}
              role="button"
              tabIndex={0}
              title="Cerrar sesión"
            >
              <Icon path={exitIcon} size={1} className="logout-icon" />
              <span className="logout-text">Cerrar sesión</span>
            </div>
            
            <div 
              className={`collapse-button${!unfoldable ? ' show-text-on-hover' : ''}`}
              onClick={() => dispatch(toggleUnfold(!unfoldable))}
              role="button"
              tabIndex={0}
              title={!unfoldable ? 'Expandir menú' : 'Colapsar menú'}
            >
              <Icon 
              path={require('materialdesign-js/icons/mdiChevronLeft').default} 
              size={1}
              className="collapse-icon"
              style={{
                transform: unfoldable ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s ease'
              }}
              />
              <span className="collapse-text">{unfoldable ? 'Expandir menú' : 'Colapsar menú'}</span>
            </div>
            </div>
        </CSidebarNav>
      </CSidebar>

      <LogoutConfirmModal
        isOpen={showLogoutModal}
        onConfirm={handleLogoutConfirm}
        onCancel={handleLogoutCancel}
      />
    </>
  ) : null;
};